import { stringFormat } from '@shared/lib/utils/stringFormat';
import { PageTypes, SummaryPageTypes } from '@shared/types';
import { getResultCertificateNumbers } from '../state/selectors/getResultCertificateNumbers';
import { DocumentResultErrorTypes, DocumentResultErrors } from '@shared/types/DocumentResultError';
import { ResultFieldProperties } from '@shared/types/ResultFieldProperties';
import { t } from 'i18next';
function checkPropertyExists(arr, type) {
    return arr.find(row => row.type === type);
}
function pushWarningOnce(errors, errorPayload) {
    const exists = errors.some(error => error.type === errorPayload.type && error.message === errorPayload.message);
    if (!exists) {
        errors.push(errorPayload);
    }
}
export function validateResults(results, id) {
    const errors = [];
    const icNumbers = Object.values(getResultCertificateNumbers(results));
    const tagExists = checkPropertyExists(results, PageTypes.tags);
    const drExists = checkPropertyExists(results, PageTypes.delivery);
    function addError(index, property, type, message) {
        errors.push({ index, property, type, message });
    }
    function markError(row) {
        return Object.assign(Object.assign({}, row), { hasError: true });
    }
    const validatedData = results.map((row, rowIndex) => {
        let newRow = row;
        if ([PageTypes.delivery, PageTypes.tags, SummaryPageTypes.summary_list].includes(row.type)) {
            if (!row.certificateNumber &&
                (row.type === PageTypes.delivery || row.type === PageTypes.tags)) {
                const message = row.type === PageTypes.tags
                    ? t(DocumentResultErrors.tagCouldNotMatchToCertificate)
                    : t(DocumentResultErrors.deliveryRecordCouldNotMatchToCertificate);
                addError(rowIndex, ResultFieldProperties.certificateNumber, DocumentResultErrorTypes.error, message);
                newRow = markError(newRow);
            }
            else if (!icNumbers.includes(row.certificateNumber) && row.certificateNumber !== null) {
                addError(rowIndex, ResultFieldProperties.certificateNumber, DocumentResultErrorTypes.warning, t(DocumentResultErrors.certificateNumberIsInvalid));
                newRow = markError(newRow);
            }
        }
        if (row.type === PageTypes.certificate) {
            if (row.calculatedQuantitiesTags !== undefined &&
                +row.quantities !== row.calculatedQuantitiesTags &&
                tagExists) {
                addError(rowIndex, ResultFieldProperties.quantities, DocumentResultErrorTypes.error, stringFormat(t(DocumentResultErrors.quantitiesDoNotMatchWithCalculatedTags), [
                    `${row.quantities}`,
                    `${row.calculatedQuantitiesTags}`
                ]));
                newRow = markError(newRow);
            }
            if (row.calculatedQuantitiesDelivery !== undefined &&
                +row.quantities !== row.calculatedQuantitiesDelivery &&
                drExists) {
                addError(rowIndex, ResultFieldProperties.quantities, DocumentResultErrorTypes.error, stringFormat(t(DocumentResultErrors.quantitiesDoNotMatchWithCalculatedDelivery), [
                    `${row.quantities}`,
                    `${row.calculatedQuantitiesDelivery}`
                ]));
                newRow = markError(newRow);
            }
        }
        const processingSheetErrors = [
            {
                condition: row.type === PageTypes.processing_sheet && row.processingTagIndex === null,
                error: DocumentResultErrors.errorMatchingProcessingSheet
            },
            {
                condition: row.type === PageTypes.processing_sheet && row.summaryListIndex === null,
                error: DocumentResultErrors.errorMatchingProcessingSheetToSummaryList
            },
            {
                condition: row.type === PageTypes.processing_tags && row.processingSheetIndex === null,
                error: DocumentResultErrors.errorMatchingProcessingTag
            },
            {
                condition: row.type === PageTypes.processing_tags && row.summaryListIndex === null,
                error: DocumentResultErrors.errorMatchingProcessingTagToSummaryList
            },
            {
                condition: row.type === SummaryPageTypes.summary_list && row.icIndex === null,
                error: DocumentResultErrors.errorMatchingProcessingSummaryList
            },
            {
                condition: row.type === SummaryPageTypes.summary_list &&
                    (!row.calculatedQuantitiesProcessingSheets ||
                        row.calculatedQuantitiesProcessingSheets <= 0),
                error: DocumentResultErrors.errorMatchingSummaryListToProcessingSheet
            },
            {
                condition: row.type === SummaryPageTypes.summary_list &&
                    (!row.calculatedQuantitiesProcessingTags || row.calculatedQuantitiesProcessingTags <= 0),
                error: DocumentResultErrors.errorMatchingSummaryListToProcessingTag
            }
        ];
        processingSheetErrors.forEach(({ condition, error }) => {
            if (condition) {
                addError(rowIndex, ResultFieldProperties.type, DocumentResultErrorTypes.error, t(error));
                newRow = markError(newRow);
            }
        });
        return newRow;
    });
    return { validatedData, errors };
}
